import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <rect width="48" height="48" rx="12" fill="#C2502A" />
    <circle cx="24" cy="21" r="8.5" fill="#F2EBDF" />
    <path d="M9 31c5-3.5 10-3.5 15 0s10 3.5 15 0" fill="none" stroke="#14110F" strokeWidth="3" strokeLinecap="round" />
    <path d="M9 37.5c5-3.5 10-3.5 15 0s10 3.5 15 0" fill="none" stroke="#F2EBDF" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const Logo = () => (
  <Link to="/" data-testid="nav-logo-link" className="group flex items-center gap-3">
    <span className="transition-transform duration-500 group-hover:rotate-[-8deg]"><LogoMark /></span>
    <span className="leading-none">
      <span className="block font-display text-2xl font-semibold tracking-tight">GAC</span>
      <span className="hidden font-mono text-[10px] uppercase tracking-[0.2em] opacity-80 sm:block">Gweagal Aboriginal Corporation</span>
    </span>
  </Link>
);
